/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React from 'react';

import { Flex, Box } from 'components/styled';

import { Theme } from 'theme';

const MainSectionItem: React.FC<{
	icon: React.FC<Pick<React.SVGProps<SVGSVGElement>, 'width'>>;
	title: string;
	children: React.ReactNode;
}> = ({ icon: Icon, title, children }) => (
	<Flex
		alignItems={['center', 'center', 'center', 'flex-start']}
		width={['100%', '100%', '100%', '190px']}
		maxWidth={['unset', 'unset', 'unset', '190px']}
		flex={1}
		height="auto"
		minHeight={['unset', 'unset', 'unset', '90px']}
		mt={[0, 0, 0, 2]}
		flexDirection={['row-reverse', 'row-reverse', 'row-reverse', 'column']}
		justifyContent={[
			'space-between',
			'space-between',
			'space-between',
			'flex-start',
		]}
	>
		<Flex
			flexDirection={['row-reverse', 'row-reverse', 'row-reverse', 'column']}
			alignItems="center"
			minWidth={['100%', '100%', '100%', 'unset']}
			justifyContent={[
				'space-between',
				'space-between',
				'space-between',
				'flex-start',
			]}
		>
			<Box
				flexShrink={0}
				title={title}
				color="primary"
				mb={[0, 0, 0, 2]}
				ml={1}
			>
				<Icon width={20} />
			</Box>
			<Box
				textAlign={['unset', 'center']}
				mx={0}
				fontSize="14px"
				mb={0}
				overflow="hidden"
				minWidth={['unset', 'unset', 'unset', '100px']}
				css={css`
					text-overflow: ellipsis;
				`}
			>
				{children}
			</Box>
		</Flex>
		<Flex
			flexGrow={[0, 0, 1, 1]}
			width={[0, 0, 1, 1]}
			css={(theme: Theme) =>
				css`
					@media (max-width: ${theme.breakpoints[2]}) {
						display: none;
					}
				`
			}
		/>
	</Flex>
);

export default MainSectionItem;
